module.exports = MessagesCtrl;

// @ngInject
function MessagesCtrl($state, $timeout, $anchorScroll, Alert, SiteVisitApi, localStorageService, moment) {
  try {
    var vm = this;
    vm.moduleName = 'MessagesCtrl'
    
    var _state = localStorageService.get('state');
    console.log(vm.moduleName, _state)
    if (_state != 'ONSITE' && _state != 'CALL_NOC') {
      $state.go('unknown');
    }

    vm.toggle = [0, 0, 0];

    // Format messages from CASDM to be presented
    var formatMessages = function () {
      if (localStorageService.get('visitMessages') === null) {
        return
      }
      var importance = "panel-info panel-info-app";
      var section = "";

      ['site', 'case', 'other'].forEach(function(category) {
        try {
          var body = [];
          switch (category) {
            case 'site':
              section = "<h2><i class=\"glyphicon glyphicon-home\" aria-hidden=\"true\"></i> Site info</h2>";
              break;
            case 'case':
              section = "<h2><i class=\"glyphicon glyphicon-tag\" aria-hidden=\"true\"></i> Case info<span class=\"label label-app label-info-app pull-right\">" + vm.case.id + "</span></h2>";
              break;
            default:
            section = "<h2><i class=\"glyphicon glyphicon-info-sign\" aria-hidden=\"true\"></i> Other info</h2>";
              break;
          };

          ['critical', 'notice', 'info'].forEach(function(importance) {
            JSON.parse(localStorageService.get('visitMessages')).forEach(function(message) {
              try {
                if (message.category === category && message.importance === importance) {
                  body.push(
                    {
                      subject: message.subject,
                      body: message.body
                    }
                  );
                };
                switch (message.subject) {
                  case 'INSA name':
                    vm.siteInsa = message.body;
                    break;
                  case 'Norkring name':
                    vm.siteNorkring = message.body;
                    break;
                };
              } catch(error) {throw(error)}
            });
          });
          
          //console.log(JSON.stringify(body, undefined, 2));
          if (body.length) {
            vm.messages.push(
              {
                heading:    section, 
                importance: importance,
                body:       body
              }
            );
            body = [];
          };
        } catch(error) {throw(error)}
      });
    };

    vm.confirmDialogue= function (msg){
      if (confirm(msg)) {
         return 1
      } else {
        return 0
      }
    };

    vm.state = localStorageService.get('state');

    vm.case = JSON.parse(localStorageService.get('case'));
		vm.visitor = JSON.parse(localStorageService.get('visitor'));
    vm.visitor.visitId = localStorageService.get('visitId');
    localStorageService.set('visitor', JSON.stringify(vm.visitor));

    vm.showOnSiteOk = true;
    vm.offSiteMode = localStorageService.get('offSiteMode');
    vm.onSiteDateTime = moment(localStorageService.get('onSiteDateTime')).format("YYYY-MM-DD hh:mm");
    vm.offSiteDateTime = moment(localStorageService.get('offSiteDateTime')).format("YYYY-MM-DD hh:mm");
    if (vm.offSiteMode !== 'CALL') {
      localStorageService.set('offSiteMode', 'INIT');
      vm.offSiteMode = 'INIT'; 
      vm.canLeave = false;
    } else {
      vm.canLeave = true;
    }
    vm.isAutoCheckOut = false;
 
    vm.messages = [];
    formatMessages();

    vm.checkOffSite = function () {
      try {
        var stat = vm.confirmDialogue("Are you sure you want to check-out?");
        if (stat != 0) {
          $timeout(function() {
            $anchorScroll();
          }, 100);
          vm.busyMsg = "Checking site alarms"
          vm.canLeave = true;
          vm.isBusy = true;
          SiteVisitApi.checkOffSite(vm.visitor, vm.case, vm.position).then(
            function(data) {
              try {
                vm.isBusy = false;
                console.log(data);
                switch (data.status) {
                  case 'OK':
                    // No site alarms -  show Dialogue to ask visitor to confirm check-out - and call "offSite" method to complete check-out if confirmed.
                    vm.isAutoCheckOut = true;
                    vm.offSiteMode = 'AUTO'; 
                    localStorageService.set('offSiteMode', vm.offSiteMode);
                    SiteVisitApi.offSite(vm.visitor, Math.floor(new Date() / 1000), vm.position).then(
                      function(data) {
                        if (data.status === "OK") {
                          vm.checkOutMsg = "Site check-out completed";
                        } else {
                          console.log(data);
                          vm.checkOutMsg = "Site check-out completed";
                        }
                      },
                      function(error) {
                        console.log('offSite:', error);
                      }
                    );
                    break;
                  case 'CALL':
                    // Visitor needs to call NOC before leaving site - set visit to "offSiteMode" state, and reload page to display "call NOC button"
                    vm.offSiteMode = 'CALL';
                    vm.isAutoCheckOut = false;
                    localStorageService.set('offSiteMode', vm.offSiteMode);
                    $state.reload();
                    break;
                  default:
                    // Other unknown status returned - visitor needs to call NOC - set visit to "offSiteMode" and reload page to display "call NOC button"
                    vm.offSiteMode = 'CALL';
                    vm.isAutoCheckOut = false;
                    localStorageService.set('offSiteMode', vm.offSiteMode);
                    $state.reload();
                    break;
                }
              } catch(error) {
                vm.isBusy = false;
                Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
                $anchorScroll();
              }
            },
            function(error) {
              vm.isBusy = false;
              // An error occurred - visitor needs to call NOC - set visit to "offSiteMode" and reload page to display "call NOC button"
              vm.offSiteMode = 'CALL';
              vm.isAutoCheckOut = false;
              localStorageService.set('offSiteMode', vm.offSiteMode);
              Alert.addAlert({ title: 'Error', message: 'Oooops - a system error has occurred :-(', type: 'errorAlert', alertClass: 'alert-danger'});
              $timeout($state.reload(), 3000);
            }
          )
        }
			} catch(error) {
				vm.isBusy = false;
				Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
				$anchorScroll();
			}
    };
    
    vm.callNoc = function () {
      // Call NOC button pressed -  show Dialogue to ask visitor to confirm check-out - and call "offSite" method to complete check-out if confirmed.
      vm.canLeave = 1;
    };

    // Function to call "offSite" method (if not manual check-out) and 
    vm.exitSite = function () {
      try {
        // Only call offSite when AUTO checkout
        if (0 && !vm.isAutoCheckOut) {
          SiteVisitApi.offSite(vm.visitor, Math.floor(new Date() / 1000), vm.position).then(
            function(data) {
              if (data.status === "OK") {
                console.log("Site check-out completed status OK");
              } else {
                console.log("Site check-out completed" + data.status);
              }
            },
            function(error) {
              console.log('Site check-out error:', error);
            }
          );
        }

        // Remove current visit data from local storage
        localStorageService.remove('case');
        localStorageService.remove('state');
        localStorageService.remove('visitId');
        localStorageService.remove('caseInfo');
        localStorageService.remove('siteInfo');
        localStorageService.remove('lastTime');
        localStorageService.remove('position');
        localStorageService.remove('offSiteMode');
        localStorageService.remove('visitMessages');
        localStorageService.remove('onSiteDateTime');
        localStorageService.remove('offSiteDateTime');
        localStorageService.remove('visitType');
        localStorageService.remove('offSiteMode');
        var visitor = JSON.parse(localStorageService.get('visitor'));
        delete visitor.visitId;
        // Only keep countryCode and phoneNumber
        localStorageService.set('visitor', JSON.stringify(visitor));
        $state.go('unknown');
			} catch(error) {
				vm.isBusy = false;
				Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
				$anchorScroll();
			}
    };
  } catch(error) {
		vm.isBusy = false;
		Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName} );
		$anchorScroll();
	}
};